// import { DocumentCard } from "./layout/DocummentCard/DocumentCard"
import { DocumentCard } from "components/ui/DocumentCard/DocumentCard"
import { useDocumentDownload } from "hooks/api/downloadFIle/documentDownload.hook"
import { useDocumentPreview } from "hooks/api/downloadFIle/documentPreview.hook"
import { useFileModalStore } from "store/modal.store"
import { Details } from "./layout/Details/Details"
import { useDocuments } from "hooks/api/drawings/drawings.hook"
import { useSearchParams } from "react-router-dom"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import { GeneralFeedback } from "./layout/GeneralFeedback/GeneralFeedback"
import { DocumentModal } from "../DocumentModal/DocumentModal"
import { useCurrentUserStore } from "store/user.store"
import type { TDrawingStatus, TFileInfo } from "types/drawer.type"
import style from "./Documents.module.scss"

const { documentsStyles, files, skeleton, generalFeedback } = style

type Props = {
	drawingStatus: TDrawingStatus
	drawingOwner: string
}

export const Documents = ({ drawingStatus, drawingOwner }: Props) => {
	const { downloadHandle } = useDocumentDownload()
	const { previewLink, previewHandle } = useDocumentPreview()

	const { isFileModalOpen, setFileModalClose } = useFileModalStore()
	const { currentUser } = useCurrentUserStore()

	const [searchParams] = useSearchParams()
	const drawingId = Number(searchParams.get("drawingID"))
	const processingId = Number(searchParams.get("processingID"))

	const { data: documents, isPending: isDocumentsPending } = useDocuments(drawingId, processingId, drawingStatus)
	const allDocuments = documents?.documents

	// Show the General Feedback component if the current user is Super Admin or user own files
	const isOwner = drawingOwner === "me"
	const isSuperAdmin = currentUser?.role === "Super Admin"
	const shouldShowFeedback = isOwner || isSuperAdmin

	return (
		<>
			<div className={documentsStyles}>
				<Details />
				{isDocumentsPending ? (
					<div className={skeleton}>
						<Skeleton rows={4} />
					</div>
				) : (
					<div className={files}>
						{allDocuments
							? allDocuments.map((item: TFileInfo) => (
									<DocumentCard
										key={item.id}
										file={item}
										downloadFile={(e) => downloadHandle(item.name, item.download_endpoint, item.type, e)}
										openFilePreview={() => previewHandle(item.download_endpoint)}
									/>
								))
							: null}
					</div>
				)}
				<div className={generalFeedback}>
					{/* Show the General Feedback component if the current user is Super Admin or user own file */}
					{shouldShowFeedback ? <GeneralFeedback drawingStatus={drawingStatus} /> : null}
				</div>
			</div>
			<DocumentModal
				isFileModalOpen={isFileModalOpen}
				setFileModalClose={setFileModalClose}
				previewLink={previewLink}
				drawingStatus={drawingStatus}
			/>
		</>
	)
}
